﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadFeatureField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadFeatureField, eOutputFieldType.cadFeature)
export class CadFeatureField extends OutputField implements ICadFeatureField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public suppressed: boolean;
    public newName: string;
    public deleted: boolean;
}
